<button (click)="buttonClicked()">{{label}}</button>